import React, { Component } from "react";
import { connect } from "react-redux";
import { assessmentActions, userActions } from "../../../_actions";
import Dashboard from "../Dashboard/Dashboard";
import Heading from "../../AdminPanel/Component/UI/Heading";
import moment from "moment";

class AssessmentCodeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      crrTeamId: "",
      searchQuery: "",
      tableData: [
        { id: 1, name: "", code: "JUxQX9dqQL", used: false, status: "Pending" },
        { id: 2, name: "", code: "JUxQX9dqQL", used: false, status: "Pending" },
        { id: 3, name: "Krishna Deva...", code: "JUxQX9dqQL", used: false, status: "In Progress" },
        { id: 4, name: "Krishna Deva...", code: "JUxQX9dqQL", used: false, status: "In Progress" },
        { id: 5, name: "Krishna Deva...", code: "JUxQX9dqQL", used: false, status: "In Progress" },
        { id: 6, name: "Krishna Deva...", code: "JUxQX9dqQL", used: false, status: "In Progress" },
        { id: 7, name: "Krishna Deva...", code: "JUxQX9dqQL", used: false, status: "In Progress" },
        { id: 8, name: "Krishna Deva...", code: "JUxQX9dqQL", used: true, status: "Completed" },
        { id: 9, name: "Krishna Deva...", code: "JUxQX9dqQL", used: true, status: "Completed" },
      ],
    };
  }

  componentDidMount() {
    this.props.dispatch(assessmentActions.userAssessmentUserProfile());
    const temp2 = {
      keyWord: "",
      pageNo: 1,
      size: 100000,
    };
    this.props.dispatch(
      assessmentActions.getCompletedTeamList(temp2, "report")
    );
  }

  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };

  switchToSelf = () => {
    this.props.dispatch(userActions.userCoachSwitchLogin({}, this.props));
  };

  handleNameChange = (id, text) => {
    this.setState((prevState) => ({
      tableData: prevState.tableData.map((row) =>
        row.id === id ? { ...row, name: text } : row
      ),
    }));
  };

  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  renderStatusBadge = (status) => {
    switch (status) {
      case "Pending":
        return (
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-gray-200/70 text-slate-700">
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Pending
          </span>
        );
      case "In Progress":
        return (
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-indigo-100 text-indigo-600">
            <svg className="w-3.5 h-3.5 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            In Progress
          </span>
        );
      case "Completed":
        return (
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-emerald-100 text-emerald-700">
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
            Completed
          </span>
        );
      default:
        return null;
    }
  };

  render() {
    const { assessment } = this.props;
    const { userAssessmentUserProfileData } = assessment;

    const getPeriod = () => {
      const hour = moment().hour();
      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };

    let userDetails = {
      name: userAssessmentUserProfileData?.name ?? "",
      email: userAssessmentUserProfileData?.email ?? "",
      period: getPeriod(),
    };

    let { loading } = assessment;

    return (
      <Dashboard userDetails={userDetails} logout={this.logout} switchToSelf={this.switchToSelf} loading={loading}>
        <div className="min-h-screen">
          <div className="w-ful mx-auto space-y-6">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div>
                <Heading className="text-2xl font-medium" title="TalentPlus Strengths 28 thems" />
                <p className="mt-1 text-sm text-gray-600">Manage and monitor AI-driven competency surveys across your organization.</p>
              </div>
              <button className="inline-flex items-center justify-center px-3 py-3 rounded-md bg-indigo-600 hover:bg-indigo-700 text-white font-medium text-base transition-colors duration-200 shadow-sm hover:shadow-indigo-100">Get Assessment Code</button>
            </div>

            <div className="bg-white rounded-2xl p-4 border border-slate-200/80 shadow-sm flex items-center justify-between gap-4">
              <button className="flex items-center gap-2 px-4 py-2 bg-slate-100 hover:bg-slate-200/70 text-slate-700 text-sm font-semibold rounded-xl transition-colors">
                <svg className="w-4 h-4 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                </svg>
                Filters
                <svg className="w-3.5 h-3.5 text-slate-500 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              <div className="flex items-center gap-3">
                <div className="relative">
                  <svg className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                  <input
                    type="text"
                    placeholder="Search"
                    className="pl-10 pr-4 py-2 w-64 bg-white border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-slate-700 placeholder-slate-400"
                  />
                </div>

                <button className="p-2 border border-slate-200 rounded-xl hover:bg-slate-50 text-slate-600 transition-colors">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                  </svg>
                </button>

                <button className="p-2 border border-slate-200 rounded-xl hover:bg-slate-50 text-slate-600 transition-colors">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </button>
              </div>
            </div>

            {/* Table Container Card */}
            <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm">
              <div className="overflow-x-auto">
                <table className="w-full text-left border-collapse">
                  <thead>
                    <tr className="bg-[#eef2fb] text-slate-700 text-xs uppercase font-bold tracking-wider border-b border-slate-200/80">
                      <th className="py-3.5 px-6">NAME</th>
                      <th className="py-3.5 px-6">Assessment Code</th>
                      <th className="py-3.5 px-6 text-center">Used</th>
                      <th className="py-3.5 px-6">Status</th>
                      <th className="py-3.5 px-6 text-right">ACTION</th>
                    </tr>
                  </thead>

                  <tbody className="divide-y divide-slate-100 text-sm font-medium">
                    {this.state.tableData.map((row) => (
                      <tr key={row.id} className="hover:bg-slate-50/70 transition-colors">
                        <td className="py-3 px-6">
                          <div className="flex items-center gap-2 max-w-[200px]">
                            <input type="text" value={row.name} placeholder="Enter name..." onChange={(e) => this.handleNameChange(row.id, e.target.value)} className="w-full px-3 py-1.5 border border-slate-200 rounded-lg text-slate-800 text-sm placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500" />
                            <button className="p-1.5 rounded-lg bg-teal-50 text-teal-700 hover:bg-teal-100 transition-colors flex-shrink-0">
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                              </svg>
                            </button>
                          </div>
                        </td>
                        <td className="py-3 px-6">
                          <div className="flex items-center gap-2">
                            <span className="px-3 py-1.5 border-2 border-dashed border-slate-300 rounded-lg text-slate-800 font-bold tracking-wide text-xs">
                              {row.code}
                            </span>
                            <button
                              onClick={() => this.copyToClipboard(row.code)}
                              className="p-1.5 rounded-lg bg-indigo-50 text-indigo-600 hover:bg-indigo-100 transition-colors"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                              </svg>
                            </button>
                          </div>
                        </td>

                        <td className="py-3 px-6 text-center font-bold">
                          {row.used ? (
                            <span className="text-emerald-700">Yes</span>
                          ) : (
                            <span className="text-red-500">No</span>
                          )}
                        </td>
                        <td className="py-3 px-6">
                          {this.renderStatusBadge(row.status)}
                        </td>

                        {/* ACTION Column */}
                        <td className="py-3 px-6 text-right">
                          <button className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-[#036a61] hover:bg-[#02544d] text-white text-xs font-semibold rounded-lg transition-colors">
                            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                            View Report
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagiantion */}
              <div className="bg-[#eef2fb] px-6 py-3 border-t border-slate-200/80 flex items-center justify-between text-xs font-semibold text-slate-600">
                <div>
                  Showing <span className="font-bold text-slate-800">5</span> of <span className="font-bold text-slate-800">128</span> employees
                </div>
                <div className="flex items-center gap-1.5">
                  <button className="p-1.5 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-500 transition-colors">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                    </svg>
                  </button>
                  <button className="w-8 h-8 rounded-lg bg-[#5046e5] text-white font-bold flex items-center justify-center">1</button>
                  <button className="w-8 h-8 rounded-lg bg-white border border-slate-200 text-slate-700 hover:bg-slate-50 font-bold flex items-center justify-center transition-colors">2</button>
                  <button className="w-8 h-8 rounded-lg bg-white border border-slate-200 text-slate-700 hover:bg-slate-50 font-bold flex items-center justify-center transition-colors">3</button>
                  <span className="px-1 text-slate-400">...</span>
                  <button className="w-8 h-8 rounded-lg bg-white border border-slate-200 text-slate-700 hover:bg-slate-50 font-bold flex items-center justify-center transition-colors">26</button>
                  <button className="p-1.5 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-500 transition-colors">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </Dashboard>
    );
  }
}

function mapStateToProps(state) {
  const { loggingIn } = state.authentication;
  const { questions, users, assessment } = state;
  return {
    loggingIn,
    questions,
    users,
    assessment,
  };
}

export default connect(mapStateToProps)(AssessmentCodeList);